'use client';
import { keyframes } from '@s7/styles';

var DEFAULT_SKELETON_ANIMATIONS = {
    pulse: keyframes({
        "0%": {
            opacity: 1
        },
        "50%": {
            opacity: 0.4
        },
        "100%": {
            opacity: 1
        }
    }),
    wave: keyframes({
        "0%": {
            transform: "translateX(-100%)"
        },
        "82%": {
            transform: "translateX(100%)"
        },
        "100%": {
            transform: "translateX(100%)"
        }
    })
};

export { DEFAULT_SKELETON_ANIMATIONS };
